module.exports = __webpack_public_path__ + "img/lumber_mill_small.aa4166a6.png";